import ChannelInfoMembers from "discourse/plugins/chat/discourse/components/chat/routes/channel-info-members";

export default <template>
  <ChannelInfoMembers @channel={{@controller.model}} />
</template>
